import { SandboxedTagMutation } from "../html-string-parser/SandboxedTagMutation";
import { globalAnchorTransformConfig } from "./GlobalAnchorTransformConfig.const";
import { AnchorTransform } from "./AnchorTransform";

export const globalAnchorTransform: SandboxedTagMutation = new AnchorTransform(globalAnchorTransformConfig);
